import { render } from "./CookiesModal.vue?vue&type=template&id=b7d73f42&scoped=true"
import script from "./CookiesModal.vue?vue&type=script&lang=js"
export * from "./CookiesModal.vue?vue&type=script&lang=js"

import "./CookiesModal.vue?vue&type=style&index=0&id=b7d73f42&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d73f42"]])

export default __exports__